import { render, staticRenderFns } from "./DashboardBlock.vue?vue&type=template&id=4b2e1eb6&scoped=true"
import script from "./DashboardBlock.vue?vue&type=script&lang=js"
export * from "./DashboardBlock.vue?vue&type=script&lang=js"
import style0 from "./DashboardBlock.vue?vue&type=style&index=0&id=4b2e1eb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e1eb6",
  null
  
)

export default component.exports